<template>
  <v-card>
    <v-card-title>
      Add prizes
    </v-card-title>
    <v-card-text>
      <v-textarea
        v-model="prizes"
        hint="comma separated: name, price, link"
        outlined
      />
    </v-card-text>
    <v-card-actions>
      <v-btn
        @click="submit"
      >
        Add Prizes
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PrizesClient from '@/api/PrizesClient';
import { mapGetters } from 'vuex';

// turn "$23", "23.50", "$23 CAD", etc into 23
const priceRegex = /\d+/;

export default {
  name: 'AddPrizes',
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      prizes: '',
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
      currentHackathonId: 'currentHackathonId',
    }),
    prizeList() {
      return this.prizes.split('\n').map((prize) => {
        const split = prize.split(',');
        return {
          name: split[0].trim(),
          price: this.parsePrice(split[1]),
          link: split[2].trim(),
        };
      });
    },
  },
  mounted() {
    this.client = new PrizesClient(this.currentJwtToken, this.currentHackathonId);
  },
  methods: {
    async submit() {
      await this.client.addPrizes(this.prizeList);
      this.prizes = '';
    },
    parsePrice(price) {
      return Number(price.match(priceRegex).pop());
    },
  },
};
</script>
